import { mainLocator as locator } from '@core/di/main.locator';
import { SequenceRepository } from '@core/sequence.repository';
import { UiService } from '@core/services/ui.services';
import ProductRepository from '@modules/chefs-assistant/pages/stock/products/product.repository';
import { ProductStore } from '@modules/chefs-assistant/pages/stock/products/product.store';
import ProductCache from '@modules/chefs-assistant/services/product.cache';

locator.register('ProductCache', ProductCache);
locator.register('ProductRepository', ProductRepository);
locator.registerInstance(
  'ProductStore',
  new ProductStore(
    locator.resolve<UiService>('UiService'),
    locator.resolve<SequenceRepository>('SequenceRepository'),
    locator.resolve<ProductRepository>('ProductRepository'),
    locator.resolve<ProductCache>('ProductCache'),
  ),
);
